import { useState } from 'react';
import { ChevronDown, ChevronUp, BookOpen } from 'lucide-react';

const SubscribedResources = ({ resources }) => {
  const [openCategory, setOpenCategory] = useState(null);

  const toggleCategory = (index) => {
    setOpenCategory(openCategory === index ? null : index);
  };

  
  return (
    <div className="p-4 md:p-8 bg-white dark:bg-gray-900 rounded-xl shadow-md">
      <h2 className="text-2xl font-bold mb-4 text-gray-800 dark:text-white">🖥️ Subscribed Resources</h2>

      {resources.map((item, index) => (
        <div key={index} className="mb-4 border-b dark:border-gray-700">
          <button
            onClick={() => toggleCategory(index)}
            className="w-full flex items-center justify-between text-left py-3 px-4 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-t-md transition-all"
          >
            <div className="flex items-center gap-2 text-gray-800 dark:text-white">
              <BookOpen className="w-5 h-5" />
              <span className="font-semibold">{item.category}</span>
            </div>
            {openCategory === index ? <ChevronUp /> : <ChevronDown />}
          </button>

          <div
            className={`overflow-hidden transition-all duration-500 ${
              openCategory === index ? 'max-h-40' : 'max-h-0'
            }`}
          >
            <div className="p-4 flex flex-wrap gap-2 bg-gray-50 dark:bg-gray-800 rounded-b-md">
              {item.publishers.map((publisher, idx) => (
                <span
                  key={idx}
                  className="px-3 py-1 text-sm bg-orange-100 dark:bg-orange-900 dark:text-white text-orange-700 rounded-full shadow-sm hover:scale-105 transition-transform cursor-pointer"
                >
                  {publisher}
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubscribedResources;
